import { Component, OnInit } from '@angular/core';
import { FiltroDealers } from './filtro-dealer';
import { PlanoFamiliaFiltrosService } from './plano-familia-filtros.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { PlanoFamiliaService } from './plano-familia.service';

@Component({
  selector: 'app-consulta-plano-familia',
  templateUrl: './consulta-plano-familia.component.html',
  styleUrls: ['./consulta-plano-familia.component.scss']
})
export class ConsultaPlanoFamiliaComponent implements OnInit {

  cols: any[] = [];
  sales: any[] = [];
  salesAgrupado: any[] = [];
  familiasColunas: string[] = [];
  dadosModelos: any[] = [];
  filtros: any = {};
  expandedRegions: { [regiao: string]: boolean } = {};
  regiao: { nome: any, valor: any }[] = [];
  displayFiltrosDealers: boolean = false;
  displayFiltros: boolean = false;
  gridModelos: boolean = false;
  dropdawn: string = 'pi pi-chevron-right';
  dataInicial: Date = new Date();
  filtrosDealers: FiltroDealers;
  form: FormGroup;

  constructor(private servico: PlanoFamiliaFiltrosService,
    private fb: FormBuilder, private service: PlanoFamiliaService) {
    this.filtrosDealers = new FiltroDealers(this.servico);

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataInicial).format('DD-MM-YYYY')],
      dealers: [''],
      id_regiao: [''],
    });
  }

  ngOnInit() {

    this.cols = [
      { field: 'mes', header: 'Mês' },
      { field: 'ano', header: 'Ano' },
      { field: 'corExternaFab', header: 'Cor Externa Fabrica' },
      { field: 'corInternaFab', header: 'Cor Interna Fabrica' },
      { field: 'codMtoc', header: 'Código Modelo MTOC' },
      { field: 'quantidadeAceite', header: 'Quantidade Aceita' },
      { field: 'quantidadeProducao', header: 'Quantidade Produção' }
    ];

    this.getAll();
    this.filtrosDealers.carregar();
  }

  getAll() {
    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.id_regiao.value)
      .subscribe(dados => {
        dados.forEach(item => {
          item.familiasMap = {};
          if (Array.isArray(item.familias)) {
            item.familias.forEach(f => {
              item.familiasMap[f.familia] = f.quantidade;
            });
          }
        });

        this.sales = dados;
        const setFamilias = new Set<string>();

        dados.forEach(item => {
          if (Array.isArray(item.familias)) {
            item.familias.forEach(f => setFamilias.add(f.familia));
          }
        });

        const famArray = Array.from(setFamilias).filter(x => x !== 'TOTAL');
        if (setFamilias.has('TOTAL')) famArray.push('TOTAL');
        this.familiasColunas = famArray;
        this.montarTabelaAgrupadaPorRegiao();
      });

  }

  montarTabelaAgrupadaPorRegiao() {
    const mapaRegioes = new Map<string, any[]>();
    const promise = this.servico.getFiltroRegional();

    promise.then(r => {
      this.regiao = (r.filtros || []).map(filtro => ({
        nome: filtro.descricao,
        valor: filtro.id.toString()
      }));
    });

    this.sales.forEach(item => {
      const regiao = item.regiao || 'SEM REGIAO';

      if (!mapaRegioes.has(regiao)) {
        mapaRegioes.set(regiao, []);
      }
      mapaRegioes.get(regiao)!.push(item);
    });
    
    this.salesAgrupado = [];
    this.expandedRegions = {};

    mapaRegioes.forEach((lista, regiao) => {
      lista.forEach(item => {
        item.isTotal = false;
        item.isDealer = true;
        item.regiao = regiao;
      });

      this.salesAgrupado.push(...lista);
      const totalLinha: any = {
        isTotal: true,
        regiao: regiao,
        name: '',
        familiasMap: {}
      };

      this.familiasColunas.forEach(f => totalLinha.familiasMap[f] = 0);

      lista.forEach(item => {
        this.familiasColunas.forEach(f => {
          const qtd = item.familiasMap[f] || 0;
          totalLinha.familiasMap[f] += qtd;
        });
      });

      this.expandedRegions[regiao] = false;
      this.salesAgrupado.push(totalLinha);
    });
  }

  toggle(regiao: string, event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.expandedRegions[regiao] = !this.expandedRegions[regiao];
    this.dropdawn = this.expandedRegions[regiao] ? "pi pi-chevron-up" : "pi pi-chevron-right";
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];
    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limpaDataInicial() {
    this.dataInicial = null;
  }

  get f() { return this.form.controls; }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.f.id_regiao.value
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  public limparFiltros() {
    this.f.id_regiao.setValue('');
  }

  public filtroAPI() {

    const primeiroDia = moment(this.dataInicial).startOf('month').format('DD-MM-YYYY');
    this.f.data_inicial.setValue(primeiroDia);

    const ultimoDia = moment(this.dataInicial).endOf('month').format('DD-MM-YYYY');
    this.f.data_final.setValue(ultimoDia);

    this.filtrosSelecionados();
    this.getAll();
    this.displayFiltros = false;
  };

  public exportExcel() { };

  getModelos(dados, nomeFamilia) {
    const dataInicial = this.f.data_inicial.value;
    this.service.getModelos(dados.idFamilia, dados.idDealer, nomeFamilia, dataInicial).subscribe(modelos => {
      this.dadosModelos = modelos;
    });
  }

  abrirModal(event, nomeFamilia) {
    this.gridModelos = true;
    this.getModelos(event, nomeFamilia);
  }

  private filtrosSelecionados() {
    const dealers = [];
    this.incluirFiltroDealers(dealers);
    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  editarLinha(row: any) {
    row.editando = true;
    row.alterado = false;
  }

  confirmarLinha(row: any) {
    row.editando = false;
    row.alterado = true;
  }

  validarQuantidade(row: any) {
    if (row.quantidadeProducao < 0) {
      row.quantidadeProducao = 0;
    }
    row.alterado = true;
  }

  salvando = false;

salvar() {

  const alterados = this.dadosModelos.filter(r => r.alterado);

  if (alterados.length === 0) {
    // se quiser, apenas fecha a modal sem salvar
    this.gridModelos = false;
    return;
  }

  const invalidos = alterados.filter(r => r.quantidadeProducao < 0);
  if (invalidos.length > 0) {
    return; // só bloqueia, sem alert
  }

  const payload = alterados.map(r => ({
    id: r.id,
    quantidadeProducao: r.quantidadeProducao,
    processado: false
  }));

  this.salvando = true;

  this.service.atualizarQuantidadeProducaoEmLote(payload)
    .subscribe({
      next: () => {
        this.salvando = false;

        // limpa flags
        alterados.forEach(r => {
          r.alterado = false;
          r.editando = false;
        });

        // FECHA A MODAL
        this.gridModelos = false;
      },
      error: () => {
        this.salvando = false;
        // erro silencioso (ou log se quiser)
      }
    });
  }

}
